var map = {
	"./kakaotalk/KakaoTalk.js": [
		3486,
		486
	],
	"./line/Line.js": [
		8947,
		947
	],
	"./viber/Viber.js": [
		1996,
		996
	],
	"./whatsapp/WhatsApp.js": [
		2791,
		791
	],
	"./zalo/Zalo.js": [
		6243,
		243
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4945;
module.exports = webpackAsyncContext;